import Vue from 'vue'
import VueRouter from 'vue-router'

import MainLayout from "@/components/layouts/MainLayout";
import Login from '@/components/pages/authentication/Login'
import SuccessLogin from '@/components/pages/authentication/SuccessLogin'
// affiliates pages
import Profiles from '@/components/pages/affiliates/Profiles'

import NotFound from '@/components/pages/NotFound'
import Forbidden from '@/components/pages/Forbidden'

import permissionGuard from "@/router/permissionGuard";
import Overview from "../components/pages/Overview";
import Payments from "../components/pages/Payments";
import PaymentMethods from "../components/pages/methods/PaymentMethods";


Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/successLogin/:token',
    component: SuccessLogin,
  },
  {
    path: '/errorlogin/:email',
    component: Login,
  },
  {
    path: '',
    name: '',
    component: MainLayout,
    meta: {
      checkPermissions: true,
    },
    children: [
      {
        path: '',
        name: 'Overview',
        component: Overview,
      },
      {
        path: '/payment-methods',
        name: 'PaymentMethods',
        component: PaymentMethods,
      },
      {
        path: '/payments',
        name: 'All Payments',
        component: Payments,
      },
      {
        path: '/payments/active',
        name: 'Active Payments',
        component: Payments,
      },
      {
        path: '/payments/pending',
        name: 'Payment Payments',
        component: Payments,
      },
      {
        path: '/payments/approved',
        name: 'Approved Payments',
        component: Payments,
      },
      {
        path: '/payments/closed',
        name: 'Closed Payments',
        component: Payments,
      },
      {
        path: '/payments/carried-over',
        name: 'Carried Over Payments',
        component: Payments,
      },
      {
        path: '/affiliates/profiles',
        name: 'Profiles',
        component: Profiles
      },
      {
        path: '/403',
        name: '403',
        component: Forbidden
      },
    ]
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '*',
    name: '404',
    component: NotFound
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach(permissionGuard);

export default router
